var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{attrs:{"loadRecaptchaScript":true,"sitekey":"6Leemv8cAAAAAIQnKHH4r1lVE_MCm6Hz9R4tRIgV"},on:{"verify":_vm.verifyMethod,"expired":_vm.expiredMethod,"render":_vm.renderMethod,"error":_vm.errorMethod}})}
var staticRenderFns = []

export { render, staticRenderFns }